export { default, ManagerDashboardContent } from './ManagerDashboardContent';
